<template>
  <main>
    <div class="hint pt-1"><span>温馨提示：目前仅提供濠江医院、澄海区人民医院开通电子胶片服务</span></div>
    <router-link
      v-for="(item, index) of list"
      :key="index"
      :to="{
        name: 'card-detail',
        params: {id: item.medical_card_id},
        query: {hospitalId: item.hospital_id}
    }">
      <div class="card p-3">
        <div class="card__hd py-1 px-2 rounded-top">
          <img
            src="@/assets/medical.png"
            alt=""
            width="52"
            height="52"
            class="medical-icon">
          {{ item.hospital_flag }}
        </div>
        <div
          class="d-flex align-items-center p-3 rounded-bottom card__bd">
          <picture class="avatar">
            <source
              srcset="@/assets/user-avatar.webp"
              type="image/webp">
            <source
              srcset="@/assets/user-avatar.png"
              type="image/png">
            <img
              src="@/assets/user-avatar.png"
              alt="头像"
              width="78"
              height="112"
              class="avatar">
          </picture>
          <div class="pl-3 card__bd__content">
            <p class="m-0">姓名：{{ item.name }}</p>
            <p class="m-0">卡号：{{ item.medical_card_id }}</p>
          </div>
          <div class="text-muted">
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </router-link>
    
<!--    <div class="p-3">
      <van-row class="pb-2">
        <van-col span="24">
          <van-button
            type="primary"
            size="large"
            @click="showHospital = true">添加就诊卡</van-button>
        </van-col>
      </van-row>
    </div>-->
    <van-actionsheet
      v-model="showHospital"
      :actions="actionsHospital"
      cancel-text="取消"
      @select="onSelectHospital"
      @cancel="onCancelHospital"
    />
  </main>
</template>

<script>
import currentCardService from '@/libs/currentCard';
export default {
  name: 'Card',
  data() {
    return {
      list: [],
      // 选医院
      showHospital: false,
      actionsHospital: [],
    };
  },
  async activated() {
    await this.handleLoad();
    await this.handleLoadHospital();
  },
  methods: {
    async handleLoad() {
      this.list = await currentCardService.listCards({hospital_id_list: '6,8'});
    },
    async handleLoadHospital() {
      const response = await this.$http.get('/patient-api/webapi/information/get-hospital-by-ids', {
        ids: '6,8',
      });
      const map = new Map();
      const list = [];
      response.forEach((item) => {
        map.set(item.name, item);
        list.push({
          name: item.name,
        });
      });
      this.hospitalMap = map;
      this.actionsHospital = list;
    },
    onSelectHospital(item) {
      const map = this.hospitalMap.get(item.name);
      this.hospitalId = map.id;
      this.hospital = item.name;
      this.showHospital = false;
      sessionStorage.setItem('bindHospitalId', map.id);
      sessionStorage.setItem('bindHospitalName', map.name);
      this.$router.push({ name: 'card-bind' });
    },
    onCancelHospital() {
      this.showHospital = false;
    },
  },
};
</script>
<style scoped>
.card__hd {
  background: url('../../assets/panel-hd.png') #168ff5 no-repeat scroll center/cover;
  color: #fff;
}

.card__bd {
  background-color: #fff;
}

.card__bd__content {
  color: #000;
  flex: 1;
}

.avatar {
  width: 39px;
  height: 56px;
}

.medical-icon {
  width: 16px;
  height: 16px;
}
.no-card {
  width: 80px;
  height: 80px;
}

.hint {
  font-size: 12px;
  text-align: center;
  color: #38f;
}
</style>
